import React, { Component } from 'react';
import { Tree } from 'primereact/tree';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TreeService } from '../LayerControlPage/TreeService';
import { Dropdown } from 'primereact/dropdown';
import LoadingPanel from '../LoadingPanel';


class CreateTreeStructureComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nodes: [], // Start with an empty array
            inputValue: '', // State to manage the input value
            lastAddedNode: null, // State to keep track of the last added node
            nodeIdCounter: 1, // State to maintain a sequential ID
            createdNodes: [],
            loading: false,
            selectedGeomType: null,
            expandedKeys: {} 

        };
        this.toast = React.createRef(); // Ref for Toast
    }

    async componentDidMount() {

        await this.getActiveStructure();

       
    }

    async getActiveStructure() {


        this.setState({ loading: true });

        try {

            let _response = await TreeService.GetLayerStructure();

            if (!_response.success) {
                this.toast.current.show({ severity: 'warn', summary: 'Bilgi', detail: _response.message, life: 3000 });
                return;
            }

            const idLast = Math.max(..._response.data.map(item => item.layerId), 0);

            const storeNodes = _response.data.map(item => ({
                key: item.layerId.toString(),
                label: item.name,
                data: item,
                children: []
            }));

            const treeNodes = this.convertToTreeNodes(_response.data);

            const expandedKeys = this.expandAllNodes(treeNodes);

            this.setState({
                nodes: treeNodes,
                createdNodes: storeNodes,
                nodeIdCounter: idLast + 1,
                lastAddedNode: storeNodes.find(i => i.key == idLast),
                expandedKeys
            });
            

        } catch (e) {

        } finally {
            this.setState({ loading: false });

        }


    }

    convertToTreeNodes(data) {
        const map = {};
        const roots = [];

        data.forEach(item => {
            map[item.layerId] = {
                key: item.layerId.toString(),
                label: item.name,
                data: item,
                children: [],
            };
        });

        data.forEach(item => {
            const treeNode = map[item.layerId];
            if (item.parentId === 0) {
                roots.push(treeNode);
            } else {
                if (map[item.parentId]) {
                    map[item.parentId].children.push(treeNode);
                }
            }
        });

        return roots;
    }

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value });
    };

    onGeomTypeChange = (e) => {
        this.setState({ selectedGeomType: e.value });

    }

    isDuplicateLabel = (nodes, label) => {
        for (let node of nodes) {
            if (node.label === label) {
                return true;
            }
            if (node.children && node.children.length > 0) {
                if (this.isDuplicateLabel(node.children, label)) {
                    return true;
                }
            }
        }
        return false;
    };
    
    handleAddNode = () => {
        const { nodes, inputValue, selectedGeomType, lastAddedNode, nodeIdCounter, createdNodes } = this.state;

        if (inputValue.trim() === '') return; // Do not add empty labels

        if (this.isDuplicateLabel(nodes, inputValue)) {
            this.toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'İsim mevcut', life: 3000 });
            return;
        }

        if (selectedGeomType == null || selectedGeomType == undefined) {
            this.toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Geometri tipi seçiniz', life: 3000 });
            return;
        }

        const newNode = {
            key: `${nodeIdCounter}`, 
            label: inputValue,
            icon: 'pi pi-fw pi-file',
            data: {
                name: inputValue,
                geomType: selectedGeomType,
                parentId: lastAddedNode ? lastAddedNode.data.layerId : 0, 
                layerId: nodeIdCounter 
            },
            children: [],
        };

        let storeNodes = [...createdNodes];
        storeNodes.push(newNode);

        let updatedNodes = [...nodes];

        let expandedKeys = { ...this.state.expandedKeys };
        
        if (lastAddedNode) {
            this.addNodeToParent(updatedNodes, lastAddedNode.key, newNode);
            expandedKeys[lastAddedNode.key] = true; 
        } else {
            updatedNodes.push(newNode);
        }

        expandedKeys[newNode.key] = true; 

        
        this.setState((prevState) => ({
            createdNodes: storeNodes,
            nodes: updatedNodes,
            inputValue: '',
            selectedGeomType: null,
            lastAddedNode: newNode, 
            nodeIdCounter: nodeIdCounter + 1, 
            expandedKeys: { ...prevState.expandedKeys, ...expandedKeys } 
        }));
    };
    
    addNodeToParent = (nodes, parentKey, newNode) => {
        for (let node of nodes) {
            if (node.key === parentKey) {
                if (!node.children) {
                    node.children = [];
                }
                node.children = [...node.children, newNode];
                return true;
            }
            if (node.children && node.children.length > 0) {
               
                if (this.addNodeToParent(node.children, parentKey, newNode)) {
                    return true; 
                }
            }
        }
        return false; 
    };
    
    expandAllNodes = (nodes) => {
        let keys = {};
        nodes.forEach(node => {
            if (node && node.key) {
                keys[node.key] = true; // Mark the node as expanded
            }
            if (node.children && node.children.length > 0) {
                const childKeys = this.expandAllNodes(node.children); // Recursively expand child nodes
                keys = { ...keys, ...childKeys };
            }
        });
        return keys;
    };

    clearNode = () => {
        this.setState({ nodes: [], nodeIdCounter: 1, lastAddedNode: null, createdNodes: [] });
    }

    saveData = async () => {
        const { createdNodes } = this.state;

        if (createdNodes.length < 1) {
            this.toast.current.show({ severity: 'warn', summary: 'Bilgi', detail: 'Eklenecek veri bulunamadı', life: 3000 });
            return;
        }

        this.setState({ loading: true });

        let requestData = createdNodes.map(i => i.data);

        try {
            let _response = await TreeService.CreateLayerStructure(requestData);

            if (!_response.success) {
                this.toast.current.show({ severity: 'warn', summary: 'Bilgi', detail: _response.message, life: 3000 });
                return;
            }

            this.toast.current.show({ severity: 'success', summary: 'Bilgi', detail: _response.message, life: 3000 });
        } catch (e) {
            this.toast.current.show({ severity: 'warn', summary: 'Bilgi', detail: "Kaydetme başarısız", life: 3000 });
        } finally {
            this.setState({ loading: false });
            this.clearNode();
            this.getActiveStructure();
        }
    }

    updateNodeLabel = (nodes, key, newLabel) => {
        return nodes.map(node => {
            if (node.key === key) {
                return { ...node, label: newLabel };
            }
            if (node.children && node.children.length > 0) {
                return { ...node, children: this.updateNodeLabel(node.children, key, newLabel) };
            }
            return node;
        });
    };

    updateCreatedNodeLabel = (nodes, key, newLabel) => {
        return nodes.map(node => {
            if (node.key === key) {
                return {
                    ...node, label: newLabel, data: { name: newLabel, parentId: node.data.parentId, layerId: node.data.layerId, geomType: node.data.geomType }
                };
            }
            if (node.children && node.children.length > 0) {
                return { ...node, children: this.updateCreatedNodeLabel(node.children, key, newLabel) };
            }
            return node;
        });
    };

    setNode = (e, node) => {
        const updatedNodes = this.updateNodeLabel(this.state.nodes, node.key, e.target.value);
        const updatedCreatedNodes = this.updateCreatedNodeLabel(this.state.createdNodes, node.key, e.target.value);
        this.setState({ nodes: updatedNodes, createdNodes: updatedCreatedNodes });
    };

    setNodeGeomType = (e, node) => {
        const updatedNodes = this.updateNodeGeomType(this.state.nodes, node.key, e.value);
        const updatedCreatedNodes = this.updateCreatedNodeGeomType(this.state.createdNodes, node.key, e.value);
        this.setState({ nodes: updatedNodes, createdNodes: updatedCreatedNodes });
    }

    updateNodeGeomType = (nodes, key, newGeomType) => {
        return nodes.map(node => {
            if (node.key === key) {
                return { ...node, data: { ...node.data, geomType: newGeomType } };
            }
            if (node.children && node.children.length > 0) {
                return { ...node, children: this.updateNodeGeomType(node.children, key, newGeomType) };
            }
            return node;
        });
    };

    updateCreatedNodeGeomType = (nodes, key, newGeomType) => {
        return nodes.map(node => {
            if (node.key === key) {
                return {
                    ...node,
                    data: { ...node.data, geomType: newGeomType }
                };
            }
            if (node.children && node.children.length > 0) {
                return { ...node, children: this.updateCreatedNodeGeomType(node.children, key, newGeomType) };
            }
            return node;
        });
    };

    removeNodeFromTree = (nodes, key) => {
        return nodes.filter(node => {
            if (node.key === key) {
                return false;
            }
            if (node.children && node.children.length > 0) {

                node.children = this.removeNodeFromTree(node.children, key);
                return true;
            }
            return true;
        });
    };

    removeNodeFromCreatedNodes = (data, targetLayerId) => {
        // Convert the array to an object for easy access by key
        const dataDict = data.reduce((acc, item) => {
            acc[item.key] = item;
            return acc;
        }, {});

        function removeChildren(parentId) {
            // Find all children of the given parentId
            const children = Object.keys(dataDict).filter(key => dataDict[key].data.parentId == parentId);

            // Recursively remove children
            children.forEach(child => {
                removeChildren(child);
                delete dataDict[child];
            });

            // Remove the parent itself
            if (dataDict[parentId]) {
                delete dataDict[parentId];
            }
        }

        // Start removal process from the target layerId
        const keysToRemove = Object.keys(dataDict).filter(key => dataDict[key].data.layerId == targetLayerId);
        keysToRemove.forEach(key => {
            removeChildren(key);
            if (dataDict[key]) {
                delete dataDict[key];
            }
        });

        // Convert the object back to an array
        return Object.values(dataDict);
    };



    removeNode = (e, node) => {
        const updatedNodes = this.removeNodeFromTree(this.state.nodes, node.key);
        const updatedCreatedNodes = this.removeNodeFromCreatedNodes(this.state.createdNodes, node.key);
        const lastAddedNode = updatedCreatedNodes.length > 0 ? updatedCreatedNodes[updatedCreatedNodes.length - 1] : null; // Update lastAddedNode

        this.setState({
            nodes: updatedNodes,
            createdNodes: updatedCreatedNodes,
            lastAddedNode: lastAddedNode
        });
    };


    createTextBox = (node, options) => {
        const geomTypeOptions = [
            { label: 'Belirsiz', value: 0 },
            { label: 'Point', value: 1 },
            { label: 'Line', value: 2 },
            { label: 'Polygon', value: 3 },
            { label: 'Nesnesiz', value: 4 }
        ];

        return (
            <>
                <InputText
                    style={{ pointerEvents: 'all' }}
                    value={node.label}
                    onChange={(e) => this.setNode(e, node)}
                />
                <Dropdown
                    value={node.data.geomType} // Use node.data.geomType
                    options={geomTypeOptions}
                    onChange={(e) => this.setNodeGeomType(e, node)} // Use a new function for handling geomType change
                    placeholder="Geometri Tipi Seçiniz"
                    style={{ pointerEvents: 'all', marginLeft: "4px", height: '3rem' }}
                />
                <Button
                    style={{ pointerEvents: 'all', marginLeft: "4px" }}
                    severity="danger"
                    icon="pi pi-trash"
                    onClick={(e) => this.removeNode(e, node)}
                />
            </>
        );
    }





    render() {
        const { nodes, inputValue, loading, selectedGeomType } = this.state;

        if (loading) {
            return (
                <>
                    <Toast ref={this.toast} />
                    <div id="blur">
                        <LoadingPanel />
                    </div>
                </>
            );
        }

        const geomTypeOptions = [
            { label: 'Belirsiz', value: 0 },
            { label: 'Point', value: 1 },
            { label: 'Line', value: 2 },
            { label: 'Polygon', value: 3 },
            { label: 'Nesnesiz', value: 4 }
        ];

        return (
            <>
                <Toast ref={this.toast} />
                <div style={{ position: 'relative', top: '25%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem', marginTop: '4rem' }}>
                        <InputText value={inputValue} onChange={this.handleInputChange} placeholder="Kırılım adı" />
                        <Dropdown
                            id="geomType"
                            value={selectedGeomType}
                            options={geomTypeOptions}
                            onChange={this.onGeomTypeChange}
                            placeholder="Geometri Tipi Seçiniz"
                            style={{ marginLeft: '10px', height: '3rem' }}
                        />
                        <Button style={{ marginLeft: '10px' }} label="Node Ekle" icon="pi pi-plus" onClick={this.handleAddNode} />
                        <Button style={{ marginLeft: '10px' }} severity="danger" icon="pi pi-trash" onClick={this.clearNode} />
                    </div>
                    <div style={{ width: '50%' }}>

                        <Tree value={nodes} nodeTemplate={this.createTextBox} className="w-full " expandedKeys={this.state.expandedKeys} />

                    </div>
                    <br />
                    <Button severity="success" label="Kaydet" icon="pi pi-check" onClick={this.saveData} />
                </div>
            </>
        );
    }
}

export default CreateTreeStructureComponent;
